import { Box } from "@mui/material";
import React from "react";

const XCenter = ({ children }) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
            }}
        >
            {children}
        </Box>
    );
};

export default XCenter;
